import { ENEMIES } from '../../data/enemies';
import { SIM_HZ } from '../../data/tuning';
import { circleAabbOverlap, createCircle, type Aabb } from '../collision';

/**
 * EN-22 Antena del "KGB de Cali" (GDD §8.3, issue #105). It never hurts: when the hitbox of the plane touches its
 * zone (a circle of `zoneRadius` centred on its tip, the edge counts as inside) it calls a hitman plane (EN-03,
 * #85), announced with INTERCEPT 1.0 s after the trigger and entering the screen 2.0 s after it. Each antenna
 * triggers once; the bribe makes the watchers look away. Pure; the runner moves the plane with stepHitmanPlane.
 *
 *   IDLE --zone touched--> TRIGGERED --its plane leaves the screen--> SPENT
 */
export const EN22 = ENEMIES['EN-22'];

/** Ticks from the trigger to the take-off of the plane (and its INTERCEPT warning). */
export const LAUNCH_TICKS = Math.round((EN22.delaySeconds - EN22.warningLeadSeconds) * SIM_HZ);

export type AntennaPhase = 'IDLE' | 'TRIGGERED' | 'SPENT';

export interface AntennaState {
  phase: AntennaPhase;
  triggeredAt: number | null;
  /** The hitman plane it called, once it has taken off. */
  hitman: { x: number; y: number } | null;
  /** Planes called so far (always 0 or 1). */
  spawned: number;
}

export const createAntenna = (): AntennaState => ({ phase: 'IDLE', triggeredAt: null, hitman: null, spawned: 0 });

/** Whether the hitbox of the plane touches the surveillance zone of an antenna at (x, y). */
export const touchesZone = (x: number, y: number, plane: Aabb): boolean => circleAabbOverlap(createCircle(x, y, EN22.zoneRadius), plane);
